import { Box, Paper, useTheme, Typography, CircularProgress, Button } from "@mui/material";
import { tokens } from "../../theme";

import { useState, useEffect } from 'react'
import { TextareaAutosize } from '@mui/material';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'

import { djangoApi } from "../../utils/axios/axios.utils";

import { useDispatch } from "react-redux";
import { updateSellersKits } from "../../store/products/products.action";

const ObservacaoKitPage = ({kitData, seller }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isLoading, setIsLoading] = useState(false);
    const [openForm, setOpenForm] = useState(false);

    const dispatch = useDispatch();

    const [values, setValues] = useState({
        observacao: kitData?.kit_observacao,
    });

    useEffect(() => {
        setValues({
            observacao: kitData?.kit_observacao
        })
    }, [kitData]);
    
    useEffect(() => {
        setValues({
            observacao: kitData?.kit_observacao
        })
    }, []);

    // Generic handler for textareas
    const handleChange = (field) => (event) => {
        setValues((prevValues) => ({
            ...prevValues,
            [field]: event.target.value,
        }));
    };

    const handleUpdateInformation = async () => {
        console.log('kitData: ', kitData)
        setIsLoading(true)
        const params = JSON.stringify(values)
        try {
            await djangoApi
                .post(`products/kits_active/${kitData?.kit_pk}/update_observacao_field/`, params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    console.log(res)
                    const { status } = res
                    const { data } = res.data;
                    if (status === 201) {
                        // dispatch(setSellersUpdated(data))
                        console.log('status ', status)
                        console.log('sellers: ', data)
                        setOpenForm(false)
                        setValues({
                            observacao: data?.observacao
                        })
                        dispatch(updateSellersKits(data, seller))
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    }

    const handleCancel = () => {
        setOpenForm(false)
    }

    const handleOpenForm = () => {
        setOpenForm(true)
    }

    return (
        <Box
            sx={{
                maxWidth: '1204px',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography color={colors.grey[100]} fontWeight={"bold"}>Observações do KIT {kitData?.kit_number}</Typography>
            {
                !openForm ?
                    <Box
                        sx={{
                            maxWidth: '1204px',
                        }}
                    >

                        <Paper
                            elevation={8}
                            sx={{
                                minHeight: '300px',
                                padding: '15px',
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                backgroundColor: colors.pink[900]
                            }}
                        >
                            <Typography>
                                {values.observacao}
                            </Typography>
                            <Button
                                onClick={handleOpenForm}
                                sx={{
                                    alignSelf: 'flex-start',
                                    minWidth: '40px',  // Sets a minimum width for the button
                                    height: '40px',     // Sets a fixed height for the button
                                    // padding: '10px',    // Adjusts padding for larger clickable area
                                    color: colors.yellow[600],
                                    fontSize: '16px',   // Increases font size
                                    borderRadius: '4px', // Optional: Adjust border radius,
                                    marginLeft: 'auto',
                                    marginTop: '-15px',
                                    marginRight: '-15px'
                                }}
                            >
                                <FontAwesomeIcon
                                    size="xs"
                                    icon={faPenToSquare}
                                />
                            </Button>
                        </Paper>
                    </Box>
                    :
                    <>
                        <TextareaAutosize
                            placeholder="Escreva aqui as observacões do kit..."
                            minRows={15}
                            value={values.observacao}
                            onChange={handleChange("observacao")}
                            style={{
                                width: '100%', // Stretch textarea to full width
                                padding: '8px',
                                fontSize: '0.6rem',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                marginTop: '8px', // Add spacing from the bottom box
                                // minWidth: "200px", // Set min-width and max-width to the same value
                                maxWidth: "1204px",
                                minHeight: '200px',
                                maxHeight: '300px'
                            }}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '10px',
                                alignSelf: 'end',
                            }}
                        >
                            <Button
                                variant="contained"
                                color="warning"
                                onClick={handleCancel}
                                disabled={isLoading} // Disable the button while loading
                                sx={{
                                    color: 'white',
                                    fontWeight: 'bold',
                                    width: '80px',
                                    marginTop: '10px'
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleUpdateInformation}
                                disabled={isLoading} // Disable the button while loading
                                startIcon={isLoading ? <CircularProgress size={24} color="inherit" /> : null}
                                sx={{
                                    color: 'white',
                                    fontWeight: 'bold',
                                    width: isLoading ? '120px' : '80px',
                                    marginTop: '10px'
                                }}
                            >
                                {isLoading ? "Salvando..." : "Salvar"}
                            </Button>
                        </Box>
                    </>
            }
        </Box>
    );
}

export default ObservacaoKitPage;